<template>
  <div>
       <h3 style="margin-bottom:0;font-family:'prohibition'; color:#999;">Week {{week}}</h3>
        <el-form label-position="top" ref="form" :model="form" >
           <el-form-item label="Welcome Message">
            <el-input
              type="textarea"
              :autosize="{ minRows: 2, maxRows: 4}"
              placeholder="Welcome Message"
              v-model="form.welcomeMessage">
            </el-input>
          </el-form-item>
          <el-form-item label="Weekly Sponsor Logo">
            <img v-bind:src="form.weeklySponsorImage" class="image-upload-placeholder weekly-sponsor"></img>
            <el-button type="defaul" @click="onUploadPartnerClicked('weeklySponsorImage')">Upload Image</el-button>
          </el-form-item>
          <el-form-item label="Weekly Sponsor URL">
            <el-input placeholder="(Optional)" v-model="form.weeklySponsorUrl"></el-input>
          </el-form-item> 
          
          
          <el-form-item label="Partner #1 Logo">
            <img v-bind:src="form.partnerOneImage" class="image-upload-placeholder"></img>
            <el-button type="defaul" @click="onUploadClicked('partnerOneImage')">Upload Image</el-button>
          </el-form-item>
          <el-form-item label="Partner #1 URL">
            <el-input placeholder="(Optional URL)" v-model="form.partnerOneLink"></el-input>
          </el-form-item> 
          <el-form-item label="Partner #1 PROMO CODE">
            <el-input placeholder="(Optional PROMO CODE)" v-model="form.partnerOnePromo"></el-input>
          </el-form-item> 

          <el-form-item label="Partner #2">
            <img v-bind:src="form.partnerTwoImage" class="image-upload-placeholder"></img>
            <el-button type="defaul" @click="onUploadClicked('partnerTwoImage')">Upload Image</el-button>
          </el-form-item>
          <el-form-item label="Partner #2 URL">
            <el-input placeholder="(Optional)" v-model="form.partnerTwoLink"></el-input>
          </el-form-item> 
          <el-form-item label="Partner #2 Promo Code">
            <el-input placeholder="(Optional PROMO CODE)" v-model="form.partnerTwoPromo"></el-input>
          </el-form-item> 

          <el-form-item label="Partner #3">
            <img v-bind:src="form.partnerThreeImage" class="image-upload-placeholder"></img>
            <el-button type="defaul" @click="onUploadClicked('partnerThreeImage')">Upload Image</el-button>
          </el-form-item>
          <el-form-item label="Partner #3 URL">
            <el-input placeholder="(Optional)" v-model="form.partnerThreeLink"></el-input>
          </el-form-item> 
          <el-form-item label="Partner #3 Promo Code">
            <el-input placeholder="(Optional)" v-model="form.partnerThreePromo"></el-input>
          </el-form-item> 

          <el-form-item label="Partner #4">
            <img v-bind:src="form.partnerFourImage" class="image-upload-placeholder"></img>
            <el-button type="defaul" @click="onUploadClicked('partnerFourImage')">Upload Image</el-button>
          </el-form-item>
          <el-form-item label="Partner #4 URL">
            <el-input placeholder="(Optional)" v-model="form.partnerFourLink"></el-input>
          </el-form-item> 
          <el-form-item label="Partner #4 Promo Code">
            <el-input placeholder="(Optional)" v-model="form.partnerFourPromo"></el-input>
          </el-form-item> 

          <el-form-item label="Partner #5">
            <img v-bind:src="form.partnerFiveImage" class="image-upload-placeholder"></img>
            <el-button type="defaul" @click="onUploadClicked('partnerFiveImage')">Upload Image</el-button>
          </el-form-item>
          <el-form-item label="Partner #5 URL">
            <el-input placeholder="(Optional)" v-model="form.partnerFiveLink"></el-input>
          </el-form-item> 
          <el-form-item label="Partner #5 Promo Code">
            <el-input placeholder="(Optional)" v-model="form.partnerFivePromo"></el-input>
          </el-form-item> 

          <el-form-item label="Partner #6">
            <img v-bind:src="form.partnerSixImage" class="image-upload-placeholder"></img>
            <el-button type="defaul" @click="onUploadClicked('partnerSixImage')">Upload Image</el-button>
          </el-form-item>
          <el-form-item label="Partner #6 URL">
            <el-input placeholder="(Optional)" v-model="form.partnerSixLink"></el-input>
          </el-form-item> 
          <el-form-item label="Partner #6 Promo Code">
            <el-input placeholder="(Optional)" v-model="form.partnerSixPromo"></el-input>
          </el-form-item> 

          <el-form-item label="Partner #7">
            <img v-bind:src="form.partnerSevenImage" class="image-upload-placeholder"></img>
            <el-button type="defaul" @click="onUploadClicked('partnerSevenImage')">Upload Image</el-button>
          </el-form-item>
          <el-form-item label="Partner #7 URL">
            <el-input placeholder="(Optional)" v-model="form.partnerSevenLink"></el-input>
          </el-form-item> 
          <el-form-item label="Partner #7 Promo Code">
            <el-input placeholder="(Optional)" v-model="form.partnerSevenPromo"></el-input>
          </el-form-item> 

          <el-form-item label="Partner #8">
            <img v-bind:src="form.partnerEightImage" class="image-upload-placeholder"></img>
            <el-button type="defaul" @click="onUploadClicked('partnerEightImage')">Upload Image</el-button>
          </el-form-item>
          <el-form-item label="Partner #8 URL">
            <el-input placeholder="(Optional)" v-model="form.partnerEightLink"></el-input>
          </el-form-item> 
          <el-form-item label="Partner #8 Promo Code">
            <el-input placeholder="(Optional)" v-model="form.partnerEightPromo"></el-input>
          </el-form-item> 

          <el-form-item label="Partner #9">
            <img v-bind:src="form.partnerNineImage" class="image-upload-placeholder"></img>
            <el-button type="defaul" @click="onUploadClicked('partnerNineImage')">Upload Image</el-button>
          </el-form-item>
          <el-form-item label="Partner #9 URL">
            <el-input placeholder="(Optional)" v-model="form.partnerNineLink"></el-input>
          </el-form-item> 
          <el-form-item label="Partner #9 Promo Code">
            <el-input placeholder="(Optional)" v-model="form.partnerNinePromo"></el-input>
          </el-form-item> 

          <el-form-item label="Partner #10">
            <img v-bind:src="form.partnerTenImage" class="image-upload-placeholder"></img>
            <el-button type="defaul" @click="onUploadClicked('partnerTenImage')">Upload Image</el-button>
          </el-form-item>
          <el-form-item label="Partner #10 URL">
            <el-input placeholder="(Optional)" v-model="form.partnerTenLink"></el-input>
          </el-form-item> 
          <el-form-item label="Partner #10 Promo Code">
            <el-input placeholder="(Optional)" v-model="form.partnerTenPromo"></el-input>
          </el-form-item> 
    
          <el-form-item>
            <el-button :loading="savingData" type="primary" class="get-started-btn" @click="onSubmit">Save</el-button>
          </el-form-item>
        </el-form>
  </div>
</template>

<script>
export default {
  name: 'start',
  props: ['week'],
  mounted: function(){
    var _this = this;
    this.$nextTick(function () {
      console.log('MOUNTED')
      if(_this.week){
        console.log('week FORM', _this.week)
        var settingsQuery = new Parse.Query('Settings');
        settingsQuery.equalTo('week', _this.week);
        settingsQuery.first()
          .then(function(result){
            console.log('PRE IF MOUNTED')
            console.log(result)
           
          console.log('POST IF MOUNTED')
          _this.form.objectId = result.id;
           console.log(_this.form.objectId )
          _this.form.welcomeMessage = result.get('welcomeMessage');
          _this.form.weeklySponsorImage = result.get('weeklySponsorImage');
          _this.form.weeklySponsorLink = result.get('weeklySponsorLink');
          
          _this.form.partnerOneImage = result.get('partnerOneImage');
          _this.form.partnerOneLink = result.get('partnerOneLink');
          _this.form.partnerOnePromo = result.get('partnerOnePromo');
          
          _this.form.partnerTwoImage = result.get('partnerTwoImage');
          _this.form.partnerTwoLink = result.get('partnerTwoLink');
          _this.form.partnerTwoPromo = result.get('partnerTwoPromo');
          
          _this.form.partnerThreeImage = result.get('partnerThreeImage');
          _this.form.partnerThreeLink = result.get('partnerThreeLink');
          _this.form.partnerThreePromo = result.get('partnerThreePromo');

          _this.form.partnerFourImage = result.get('partnerFourImage');
          _this.form.partnerFourLink = result.get('partnerFourLink');
          _this.form.partnerFourPromo = result.get('partnerFourPromo');

          _this.form.partnerFiveImage = result.get('partnerFiveImage');
          _this.form.partnerFiveLink = result.get('partnerFiveLink');
          _this.form.partnerFivePromo = result.get('partnerFivePromo');

          _this.form.partnerSixImage = result.get('partnerSixImage');
          _this.form.partnerSixLink = result.get('partnerSixLink');
          _this.form.partnerSixPromo = result.get('partnerSixPromo');

          _this.form.partnerSevenImage = result.get('partnerSevenImage');
          _this.form.partnerSevenLink = result.get('partnerSevenLink');
          _this.form.partnerSevenPromo = result.get('partnerSevenPromo');

          _this.form.partnerEightImage = result.get('partnerEightImage');
          _this.form.partnerEightLink = result.get('partnerEightLink');
          _this.form.partnerEightPromo = result.get('partnerEightPromo');

          _this.form.partnerNineImage = result.get('partnerNineImage');
          _this.form.partnerNineLink = result.get('partnerNineLink');
          _this.form.partnerNinePromo = result.get('partnerNinePromo');

          _this.form.partnerTenImage = result.get('partnerTenImage');
          _this.form.partnerTenLink = result.get('partnerTenLink');
          _this.form.partnerTenPromo = result.get('partnerTenPromo');
          
          



            
          })
      }
    })
  },
  data () {
    return {
      settingsId:null,
      checked:false,
      plans:[false, false, false],
      form: {
          objectId:null,
          week:null,
          welcomeMessage:null,
          weeklySponsorImage:null,
          weeklySponsorLink:null,
          partnerOneImage:null,
          partnerTwoImage:null,
          partnerThreeImage:null,
          partnerFourImage:null,
          partnerFiveImage:null,
          partnerSixImage:null,
          partnerSevenImage:null,
          partnerEightImage:null,
          partnerNineImage:null,
          partnerTenImage:null,

          partnerOneLink:null,
          partnerTwoLink:null,
          partnerThreeLink:null,
          partnerFourLink:null,
          partnerFiveLink:null,
          partnerSixLink:null,
          partnerSevenLink:null,
          partnerEightLink:null,
          partnerNineLink:null,
          partnerTenLink:null,

          partnerOnePromo:null,
          partnerTwoPromo:null,
          partnerThreePromo:null,
          partnerFourPromo:null,
          partnerFivePromo:null,
          partnerSixPromo:null,
          partnerSevenPromo:null,
          partnerEightPromo:null,
          partnerNinePromo:null,
          partnerTenPromo:null,

      },
      savingData: false,
    }
  },
  methods:{
    selectPlan(){

    },
    expandAdvanced:function(){

    },
    expandBasic:function(){

    },
    expandOneOnOne:function(){

    },
    onSubmit:function(){
      var _this = this;
      var Settings= Parse.Object.extend('Settings');
      var settings = new Settings();
       _this.form.week = _this.week;
      _this.savingData = true;
      settings.set('week', this.week);
      settings.save(_this.form)
        .then(function(savedSettings){
          if(!_this.settingsId) _this.settingsId = savedSettings.id;
          _this.savingData = false;
          _this.$message({
                  type: 'success',
                  message: 'Settings for Week '+_this.week+" have been saved."
              });
        })
        .catch(function(err){

        });
      
    },
    goToSignup:function(){
      this.$router.push('/signup/plan');
    },
    onUploadClicked:function(fieldName) {
        var _this = this;
        window.fsClient.pick({
          maxSize: 5*1024*1024,
          maxFiles:1,
          fromSources:["local_file_system","imagesearch","facebook","instagram","dropbox"]
        }).then(function(response) {
          // declare this function to handle response
          console.log(fieldName);
          if(response.filesUploaded.length){
             _this.form[fieldName] = response.filesUploaded[0].url;
          }
        });
    },
    onUploadPartnerClicked:function(fieldName) {
        var _this = this;
        window.fsClient.pick({
          maxSize: 5*1024*1024,
          maxFiles:1,
          transformations: {
            crop: {
              aspectRatio: 16/4,
              force:true
            },
          },
          fromSources:["local_file_system","imagesearch","facebook","instagram","dropbox"]
        }).then(function(response) {
          // declare this function to handle response
          console.log(response);
          if(response.filesUploaded.length){
             _this.form.weeklySponsorImage = response.filesUploaded[0].url;
          }
         
        });
    }
  }
}
</script>

<style>
.image-upload-placeholder{
  width:100px;
  min-height:50px;
  border: 2px dashed #EEE;
  display:inline-block;
  float:left;
  outline:0;
  margin-right:20px;
}
.image-upload-placeholder.weekly-sponsor{
  width:200px;
  max-height:60px;
}
hr {
    display: block;
    height: 1px;
    border: 0;
    border-top: 1px solid #ccc;
    margin: 1em 0;
    padding: 0; 
}
.get-started-container.sponsors{
  background-color: #FFF;
  width: 100%;
  display: inline-block;
  margin-bottom: 30px;    
  box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
  text-align: left;
  padding: 10px 20px;
}
.get-started-container.sponsors form {
  max-width: 800px;
  margin:30px auto;
}
.get-started-container h1 {
  width: 100%;
  padding: 20px 30px 5px;
  margin: 0;
  color: #666;
  font-family: prohibition;
  text-align: center;
  font-size: 30px;
  box-sizing: border-box;
}
.get-started-container.sponsors label {
  margin-bottom:0px;
  height:34px;
}
.get-started-container .el_select {
  width: 100%;
}
.get-started-container a{
  color: #d7347d;
}
.get-started-container p{
  text-align: center;
  color: #666;
}
.article-body {
  padding: 0 30px;
  text-align: left;
  margin-bottom: 30px;
}
.article-body p{
  margin:5px 0 10px;
  color: #999;
  line-height: 26px;

}
.el-input-group__append{
  width: 40px;
}
.get-started-btn {
  width: 100%;
}
.get-started-container .el-card{
  margin-bottom: 10px;
  position: relative;
  padding-left: 30px;
}
.get-started-container .el-card .el-card__body{
 padding: 10px 30px 10px 10px;
 line-height: 20px
}
.get-started-container .el-card .indicator {
  position: absolute;
  left:12px;
  top:12px;
  width: 16px;
  height: 16px;
  border-radius: 20px;
  border:1px solid #EEE;
  background-color: #FAFAFA;
}
.get-started-container .el-card span{
  position: absolute;
  top:10px;
  right:20px;
  font-weight: bold;
  font-size: 18px;
  color: #999;
}
.get-started-container .el-card {
  border:1px solid #EEE;
  border-radius: 4px;

}

</style>
